import { styled, Typography } from '@mui/material'

export const Loader = styled(Typography)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: 6
}))
